import { useUser } from "src/contexts/user-context";
import { isAdminWithWritePrivilege } from "src/utils/user";

/** Dev settings are for Hightouch devs (any `*.hightouch.dev` host) and admins with write access. */
export const useCanUseDevSettings = (): boolean => {
  const { user } = useUser();
  return (
    window.location.hostname.endsWith(".hightouch.dev") ||
    isAdminWithWritePrivilege(user?.admin_type)
  );
};
